import { render, staticRenderFns } from "./imUpload.vue?vue&type=template&id=57b381dd&scoped=true"
import script from "./imUpload.vue?vue&type=script&lang=js"
export * from "./imUpload.vue?vue&type=script&lang=js"
import style0 from "./imUpload.vue?vue&type=style&index=0&id=57b381dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b381dd",
  null
  
)

export default component.exports